import React from 'react';

import { Box, Text } from '@mantine/core';
import { IconInfoSquare } from '@tabler/icons-react';
import KiloTooltip from 'components/KiloTooltip';

const ChangeHeader = (): JSX.Element => {
  return (
    <Box display='flex'>
      <Text>Change%</Text>{' '}
      <KiloTooltip
        multiline
        withinPortal
        position='bottom-end'
        withArrow
        label='The change value reflects the difference in utilization rate between the selected period and the equivalent previous period.'
      >
        <IconInfoSquare size={16} style={{ cursor: 'help' }} />
      </KiloTooltip>
    </Box>
  );
};

export default ChangeHeader;
